<template>
  <v-container>
      <v-row justify="center">
        <v-col sm="12" md="10" lg="8">
          <v-card>
            <v-card-title>
              <v-icon left>
                fas fa-cubes
              </v-icon>
              Work Orders
              <v-spacer />
              <v-text-field
                class="px-3"
                prepend-inner-icon="search"
                v-model="search"
                hide-details
              />
              <WorkOrderForm
                :is-edit="false"
                :is-duplicate="false"
                :projid="id"
              />
            </v-card-title>
            <WorkOrderTable
              :id="id"
              :workorders="workorders"
              :search="search"
            />
          </v-card>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import WorkOrder from "../../models/WorkOrder";
import WorkOrderTable from "../../components/WorkOrders/WorkOrderTable";
import WorkOrderForm from "../../components/WorkOrders/WorkOrderForm";
export default {
  name: "ProjectWorkOrdersListView",
  components: { WorkOrderForm, WorkOrderTable },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      search: ""
    }
  },
  computed: {
    workorders() {
      return WorkOrder.query()
        .where("project_id", parseInt(this.id))
        .with("state")
        .with("coating")
        .with("material")
        .with("children")
        .with("tool")
        .get();
    }
  }
}
</script>
